import React, { useState, useEffect } from "react";
import Radium from "radium";
import { Icon, Popup, Button, Label, Message } from "semantic-ui-react";
import { toast } from "react-toastify";

const styles = {
	buttonWrapper: {
		width: "100%",
		height: 40,
		position: "relative",
	},
	scanInput: {
		borderRadius: 5,
		fontSize: 18,
		outline: 0,
		border: 0,
		minWidth: "115px",
		maxWidth: "150px",
		margin: "5px",
		textAlign: "center",
	},
	checkIco: {
		margin: "-13px",
		backgroundColor: "white",
		borderRadius: "15px",
		display: "inline",
		left: "-12px",
		position: "relative",
	},
};

const ButtonBarcodeTube = ({ barcode, onClick, type, disabled, isSelected, regex, submitBarCode, cancelSelect, select, aliquotPrimary = null }) => {
	const [scanInputValue, setScanInputValue] = useState("");
	const [primaryInputValue, setPrimaryInputValue] = useState("");
	const [editBarcode, setEditBarcode] = useState(isSelected);
	const [isOpen, setIsOpen] = useState(false);
	const [histoBarcode, setHistoBarcode] = useState(barcode ?? "");
	const [aliquotPrimaryVerified, setAliquotPrimaryVerified] = useState(false);
	const [aliquotPrimaryScanError, setAliquotPrimaryScanError] = useState("");
	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			if (scanInputValue !== "" && !new RegExp(regex).test(scanInputValue))
				toast.error(
					"Attention ! Le tube scanné n’est pas celui attendu. Veuillez vérifier la concordance « Tube » - « Pictogramme » et recommencez."
				);
			if (scanInputValue === "" || new RegExp(regex).test(scanInputValue)) submit(scanInputValue);
		}
	};
	const handleKeyDownPrimary = (event) => {
		if (event.key === "Enter") {
			if (primaryInputValue === aliquotPrimary.provider_barcode) {
				setAliquotPrimaryVerified(true);
				setPrimaryInputValue("");
			}
			setAliquotPrimaryScanError(primaryInputValue === "" || primaryInputValue !== aliquotPrimary.provider_barcode);
		}
		setScanInputValue("");
	};
	useEffect(() => {
		setScanInputValue(barcode ?? "");
	}, [barcode]);

	const submit = (value) => {
		submitBarCode(value);
		setEditBarcode(false);
		if (value !== "") setHistoBarcode(value);
	};
	const handleOpen = () => {
		setIsOpen(true);
		setEditBarcode(false);
		select();
	};

	const handleClose = () => {
		setIsOpen(false);
		setEditBarcode(false);
	};

	const qrcodeButton = (barcode, isSelected, notMarginTop) => ({
		backgroundColor: barcode === null || isSelected ? "#5f9be0" : "transparent",
		height: 40,
		width: "100%",
		color: barcode === null || isSelected ? "#fff" : "#5f9be0",
		marginTop: notMarginTop ? "0px" : "10px",
		marginBottom: 10,
		fontFamily: "Lato",
		textTransform: "uppercase",
		padding: 5,
		fontSize: "0.8em",
		fontWeight: 600,
		cursor: "pointer",
		outline: "none",
		border: barcode === null ? "1px solid transparent" : "1px solid #5f9be0",
		borderRadius: "4px",
		marginRight: 10,
		boxShadow: "0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset",
		transition: "opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease",
		alignItems: "center",
		justifyContent: "center",
		display: "flex",
		":hover": {
			backgroundColor: "#4d7eb8",
			boxShadow: "0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset",
			color: "#fff",
		},
		":disabled": {
			backgroundColor: "#D3D3D3",
		},
	});

	return (
		<>
			{aliquotPrimary && barcode === null && scanInputValue === "" && aliquotPrimary.provider_barcode === "" && (
				<Message>Le code-barres du tube primaire n'a pas été encodé. </Message>
			)}
			{aliquotPrimary && barcode === null && scanInputValue === "" && !aliquotPrimaryVerified && aliquotPrimary.provider_barcode !== "" && (
				<Message icon>
					<Icon name="info" />
					<Message.Content>
						<Message.Header>Tube primaire à scanner</Message.Header>
						Pour scanner le code-barres de l’aliquot, vous devez d'abord scanner le code-barres du tube primaire.
					</Message.Content>
				</Message>
			)}
			{aliquotPrimary && barcode === null && scanInputValue === "" && !aliquotPrimaryVerified && (
				<Label color="orange">
					<Icon name="lab" />
					<Icon name="barcode" />
					Tube primaire :
				</Label>
			)}

			{!!barcode && (
				<Popup
					content={
						<>
							<Button
								animated="vertical"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									navigator.clipboard.writeText(barcode);
									toast.success("Code-barres copié !");
								}}
							>
								<Button.Content hidden>Copier</Button.Content>
								<Button.Content visible>
									<Icon name="copy outline" />
								</Button.Content>
							</Button>
							<Button
								animated="vertical"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									handleClose();
									select();
									setEditBarcode(true);
								}}
							>
								<Button.Content hidden>Modifier</Button.Content>
								<Button.Content visible>
									<Icon name="edit outline" />
								</Button.Content>
							</Button>

							<Button
								animated="vertical"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									handleClose();
									select();
									setHistoBarcode(barcode);
									submit("");
									cancelSelect();
								}}
							>
								<Button.Content hidden>Effacer</Button.Content>
								<Button.Content visible>
									<Icon name="trash alternate outline" />
								</Button.Content>
							</Button>
						</>
					}
					on="click"
					open={isOpen}
					onClose={handleClose}
					onOpen={handleOpen}
					pinned
					basic
					trigger={
						<button
							key={"btnPopup" + type}
							style={qrcodeButton(barcode, isSelected, !!aliquotPrimary && barcode === null && !aliquotPrimaryVerified)}
							type={type}
							disabled={disabled}
						>
							<Icon name="barcode" size="large" style={styles.icon} />
							{isSelected && editBarcode && (
								<>
									<input
										style={styles.scanInput}
										autoFocus
										autoComplete="off"
										type="text"
										name="scanned-value"
										onChange={(e) => setScanInputValue(e.target.value)}
										value={scanInputValue}
										onKeyDown={handleKeyDown}
									/>
								</>
							)}
							{!(isSelected && editBarcode) && (barcode ?? "Scanner")}
						</button>
					}
				/>
			)}
			{(barcode === null || barcode === "") && (
				<button
					key={"btn" + type}
					style={qrcodeButton(barcode, isSelected, !!aliquotPrimary && barcode === null && !aliquotPrimaryVerified)}
					type={type}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						setEditBarcode(true);
						onClick();
					}}
					disabled={disabled}
				>
					<Icon name="barcode" size="large" style={styles.icon} />
					{isSelected && (!aliquotPrimary || aliquotPrimaryVerified) && (
						<>
							{histoBarcode !== "" && <Popup content={histoBarcode} trigger={<Icon name="history" onClick={() => submit(histoBarcode)} />} />}
							<input
								style={styles.scanInput}
								autoFocus
								autoComplete="off"
								type="text"
								name="scanned-value"
								onChange={(e) => {
									setScanInputValue(e.target.value);
								}}
								value={scanInputValue}
								onKeyDown={handleKeyDown}
							/>
						</>
					)}
					{isSelected && aliquotPrimary && !aliquotPrimaryVerified && (
						<>
							<input
								style={styles.scanInput}
								autoFocus
								autoComplete="off"
								type="text"
								name="scanned-value"
								onChange={(e) => {
									setPrimaryInputValue(e.target.value);
								}}
								value={primaryInputValue}
								onKeyDown={handleKeyDownPrimary}
							/>
						</>
					)}
					{!isSelected && "Scanner"}
				</button>
			)}
			{aliquotPrimaryScanError && scanInputValue === "" && (
				<>
					<Label basic color="red">
						Le code-barres scanné ne correspond pas à celui du tube primaire. Veuillez réessayer.
					</Label>
				</>
			)}
		</>
	);
};

export default Radium(ButtonBarcodeTube);
